import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FwcDatePicker, FwcTooltip } from '../../../../fwc-lib.js';
import moment from 'moment';
import { AppConstants } from '../../constants/app-constants';
import { UserCacheService } from '../../services/user-cache.service';
@Component({
    selector: 'app-select-coverage',
    templateUrl: './select-coverage.component.html',
    styleUrls: ['./select-coverage.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class SelectCoverageComponent implements OnInit {
  @Input() content: any;
  // @Input() selectCoverage: any;
  @Input() termsData: any;
  @Output() selectedCoverage: EventEmitter<any> = new EventEmitter<any>();
  @Input() path: string;
  //@Output() selectedCoverage: EventEmitter<any> = new EventEmitter<any>();
  newEnrollmentAgreement: any;
  termIsSelected: false;
  selectedTermId: any;
  selectedTerm: any;
  //termWaived: any;
  partnerRadio = false;
  childRadio = false;
  showStartDate = false;
  showToDate = false;
  public fromDate: any = '';
  public toDate: any = '';
  public toDateRange: any;
  public dateRangeMax: any = new Date();
  childCount = [{ count: 1, checked: false }, { count: 2, checked: false }, { count: 3, checked: false }, { count: 4, checked: false }, { count: 5, checked: false }, { count: 'Other', checked: false }];
  selectedChildCount: any;
  showInput = false;
  showDependents = false;
  enrollmentType: any = '';
  totalDependentCount = 0;
  enrollmentModel: any;

  constructor(private userCacheService: UserCacheService) {
    const fwcTooltip = new FwcTooltip();
    fwcTooltip.build();
  }

  ngOnInit(): void {
    const fwcDatePicker = new FwcDatePicker();
    this.enrollmentType = this.userCacheService.getUserData(AppConstants.ENROLLMENT_TYPE);
    this.dataCleanupDependentPlus();
    this.setTermsdata();
    this.setSelectCoverageValues();
    // let datePickerTwo = document.getElementById("DatePickerTwo");
    // // set min range to 1 months in the past
    // this.dateRangeMin.setDate(this.dateRangeMin.getDate() - 120);
    // // set max range to 3 months in the future
    // this.dateRangeMax.setDate(this.dateRangeMax.getDate() + 3);

    fwcDatePicker.build();
    // if (this.selectCoverage) {
    //   this.selectedTerm = this.selectCoverage.cardId;
    // }
    this.calculateDependent(this.partnerRadio, this.selectedChildCount);
  }

  dataCleanupDependentPlus() {
    try {
      if (this.termsData && this.termsData.length > 0) {
        this.termsData = this.termsData.map((term: any) => {
          if(term.dependents_oneplus_total && term.dependents_oneplus_total > 0) {
            term.dependents_twoplus_total = null;
            term.dependent2_subtotal = null;
            term.dependent2_school_admin = null;
            term.dependents_threeplus_total = null;
            term.dependent3_subtotal = null;
            term.dependent3_school_admin = null;
          } else if(term.dependents_twoplus_total && term.dependents_twoplus_total > 0) {
            term.dependents_threeplus_total = null;
            term.dependent3_subtotal = null;
            term.dependent3_school_admin = null;
          }
          return term;
        });
      }
    } catch (error: any) {
      console.error('Error in dataCleanupDependentPlus: ' + JSON.stringify(error.message));
    }
  }

  setTermsdata(): void {
    if (this.termsData) {
      this.termsData.forEach(term => {
        if (term.payment_frequency === 'monthly' || term.payment_frequency === 'weekly') {
          const pastdate = new Date();
          pastdate.setDate(pastdate.getDate() - 60);
          let fromDate: any;
          const endDateMoment = /^\d{1,2}\/\d{1,2}\/\d{4}/.test(term.coverage_end) ? moment(term.coverage_end, 'MM/DD/YYYY') : moment(term.coverage_end, 'YYYY-MM-DD');
          if (moment(term.coverage_start).isSameOrAfter(pastdate, 'day')) {
            term.coverage_start = term.coverage_start ? this.formatDate(term.coverage_start) : term.coverage_start;
            fromDate = new Date(term.coverage_start);
            term.fromDate = fromDate;
          } else {
            fromDate = new Date().setDate(new Date().getDate() - 60);
          }
          term.fromDateRange = JSON.stringify([fromDate, new Date(term.coverage_end)]);
          // term.toDateRange = JSON.stringify([fromDate, new Date(term.coverage_end)]);
          // term.toDate = new Date(term.coverage_end);
          term.toDateRange = JSON.stringify([fromDate, endDateMoment]);
          term.toDate = endDateMoment;
        }
        term.monthly_student_total = term.student_total ?? 0;
        term.monthly_spouse_total = term.spouse_total ?? 0;
        term.monthly_child_total = term.child_total ?? 0;
        term.monthly_child_bulk_total = term.child_bulk_total ?? 0;
        term.monthly_dependents_oneplus = term.dependents_oneplus_total ?? 0;
        term.monthly_dependents_twoplus = term.dependents_twoplus_total ?? 0;
        term.monthly_dependents_threeplus = term.dependents_threeplus_total ?? 0;
        term.hideStudentRate = false;
        if ((term.spouse_total || term.spouse_total === 0) || (term.child_total || term.child_total === 0) || (term.child_bulk_total || term.child_bulk_total === 0) || (term.dependents_oneplus_total || term.dependents_oneplus_total === 0) || (term.dependents_twoplus_total || term.dependents_twoplus_total === 0) || (term.dependents_threeplus_total || term.dependents_threeplus_total === 0)) {
          this.showDependents = true;
        }
        if (this.enrollmentType === 'mandatory' && ((term.spouse_total || term.spouse_total === 0) || (term.child_total || term.child_total === 0) || (term.child_bulk_total || term.child_bulk_total === 0) || (term.dependents_oneplus_total || term.dependents_oneplus_total === 0) || (term.dependents_twoplus_total || term.dependents_twoplus_total === 0) || (term.dependents_threeplus_total || term.dependents_threeplus_total === 0))) {
          term.hideStudentRate = true;
          term.monthly_student_total = 0;
          term.student_total = 0;
        }
        if (this.enrollmentType === 'dependent-only') {
          term.hideStudentRate = true;
          term.monthly_student_total = 0;
          term.student_total = 0;
        }
      });
    }
  }

  calculateDependent(partnerRadio: boolean, selectedChildCount: number): void {
    let total = 0;
    if (partnerRadio === true) {
      total = 1;
    }
    if (this.childRadio === true && selectedChildCount > 0) {
      total += selectedChildCount;
    }
    this.totalDependentCount = total;
  }

  setSelectCoverageValues(): void {

    if (this.path === 'new-enrollment') {
      this.enrollmentModel = this.userCacheService.getUserData(AppConstants.NewEnrollmentModel);
    } else if (this.path === 'waiver') {
      this.enrollmentModel = this.userCacheService.getUserData(AppConstants.WaiverModel);
    }
    if (this.enrollmentModel) {
      this.partnerRadio = this.enrollmentModel.spouseSelected;
      this.childRadio = this.enrollmentModel.childSelected;
      this.selectedChildCount = this.enrollmentModel.childCount;
      this.calculateDependent(this.partnerRadio, this.selectedChildCount);
      if (this.selectedChildCount > 5) {
        this.showInput = true;
      }
      if (this.enrollmentModel.childSelected) {
        if (this.enrollmentModel.childCount > 5) {
          this.childCount[5].checked = true;
        } else {
          if (this.childCount.length > 0) {
            this.childCount[this.enrollmentModel.childCount - 1].checked = true;
          }
        }
      }
      if (this.enrollmentModel.startDate) {
        this.fromDate = this.enrollmentModel.startDate;
      }
      if (this.enrollmentModel.endDate) {
        this.toDate = this.enrollmentModel.endDate;
      }

      this.selectedTerm = this.enrollmentModel.selectedTerm;
      if (!this.selectedTerm) {
        const index = this.termsData.findIndex(term => term.term_id === this.enrollmentModel.selectedTermId);
        this.selectedTerm = index >= 0 ? this.termsData[index] : [];
      }
      this.selectedTerm.toDate = this.toDate;
      this.selectedTerm.fromDate = this.fromDate;
      this.selectedTermId = this.enrollmentModel.selectedTermId;
      this.newEnrollmentAgreement = true;
    } else if (this.termsData) {
      this.termsData.forEach(term => {
        if (term.payment_frequency === 'monthly' || term.payment_frequency === 'weekly') {
          this.fromDate = new Date();
          this.toDate = term.coverage_end;
        }
      });
    }
    else {
      this.fromDate = new Date();
      this.toDate = new Date();
      this.toDate.setDate(this.toDate.getDate() + 60);
    }
    this.showStartDate = true;
  }

  selectTerm(cardId, card): void {
    if (card.payment_frequency === 'monthly') {
      // this.termWaived.from = this.fromDate;
      // this.termWaived.to = this.toDate;
      this.fromDate = card.fromDate;
      this.toDate = card.toDate;
    }
    this.selectedTermId = card.term_id;
    this.selectedTerm = card;
    this.selectedCoverage.emit({ term: this.selectedTerm, spouseSelected: this.partnerRadio, childSelected: this.childRadio, selectedChildCount: this.selectedChildCount });
    // this.termWaived.cardId = cardId;
  }

  updateDob(e, value, card): void {
    let dob;
    dob = this.formatDate(e.detail);
    if (!card.fromDate) {
      if (moment(card.coverage_start).isAfter(this.fromDate, 'day')) {
        dob = card.coverage_start;
        card.fromDate = card.coverage_start;
      } else {
        dob = moment(new Date()).format('MM/DD/YYYY');
        card.fromDate = moment(new Date()).format('MM/DD/YYYY');
      }
      card.coverage_end = moment(card.coverage_end).format('MM/DD/YYYY');
      card.toDate = moment(card.coverage_end).format('MM/DD/YYYY');
    }

    if (value === 'from') {
      // card.toDateRange = JSON.stringify([e.detail, new Date(card.coverage_end)]);
      this.fromDate = dob;
      card.fromDate = dob;
      // set min range to 1 months in the past
      // this.fromDateRange = JSON.stringify([new Date().setDate(new Date().getDate() - 120), new Date(card.coverage_end)]);
      //card.toDateRange = JSON.stringify([new Date().setDate(new Date().getDate() - 120), new Date(card.coverage_end)]);

    } else if (value === 'to') {
      if (dob && dob !== 'Invalid date') {
        this.toDate = dob;
        card.toDate = dob;
        this.showToDate = true;
      } else if (dob && dob === 'Invalid date') {
        this.showToDate = false;
      }
      // set max range to 3 months in the future
      //this.toDateRange = JSON.stringify([new Date().setDate(new Date().getDate() - 120), new Date(card.coverage_end)]);
    }
    if (card.fromDate && card.toDate) {
      const a = moment(card.fromDate);
      //moment not handling month diff so adding one day
      const b = moment(card.toDate).add(1, 'days');
      const diff = b.diff(a, 'days'); // 1
      card.student_total = card.student_total ?? 0;
      if (card.spouse_total !== null) {
        card.spouse_total = card.spouse_total ?? 0;
      }
      if (card.child_total !== null) {
        card.child_total = card.child_total ?? 0;
      }
      if (card.child_total !== null) {
        card.child_bulk_total = card.child_bulk_total ?? 0;
      }
      if (card.payment_frequency === 'monthly') {
        const months = b.diff(a, 'months');
        //b.add(-2, 'days');
        a.add(months, 'months');
        const days = Math.max(b.diff(a, 'days'), 0);
        // 8 years 5 months 2 days
        card.monthly_student_total = card.student_total * months + (((card.student_total * 12) / 365) * days);
        card.monthly_spouse_total = card.spouse_total * months + (((card.spouse_total * 12) / 365) * days);
        card.monthly_child_total = card.child_total * months + (((card.child_total * 12) / 365) * days);
        card.monthly_child_bulk_total = card.child_bulk_total * months + (((card.child_bulk_total * 12) / 365) * days);
        card.monthly_dependents_oneplus = card.dependents_oneplus_total ? card.dependents_oneplus_total * months + (((card.dependents_oneplus_total * 12) / 365) * days) : 0;
        card.monthly_dependents_twoplus = card.dependents_twoplus_total ? card.dependents_twoplus_total * months + (((card.dependents_twoplus_total * 12) / 365) * days) : 0;
        card.monthly_dependents_threeplus = card.dependents_threeplus_total ? card.dependents_threeplus_total * months + (((card.dependents_threeplus_total * 12) / 365) * days) : 0;
      } else if (card.payment_frequency === 'weekly') {
        card.monthly_student_total = ((card.student_total / 7) * diff);
        card.monthly_spouse_total = ((card.spouse_total / 7) * diff);
        card.monthly_child_total = ((card.child_total / 7) * diff);
        card.monthly_child_bulk_total = ((card.child_bulk_total / 7) * diff);
        card.monthly_dependents_oneplus = card.dependents_oneplus_total ? ((card.dependents_oneplus_total / 7) * diff) : 0;
        card.monthly_dependents_twoplus = card.dependents_twoplus_total ? ((card.dependents_twoplus_total / 7) * diff) : 0;
        card.monthly_dependents_threeplus = card.dependents_threeplus_total ? ((card.dependents_threeplus_total / 7) * diff) : 0;
      }
    }
  }

  radioChange(value, from): void {
    if (from === 'partner') {
      this.partnerRadio = value;
    } else {
      this.childRadio = value;
    }
    if (this.childRadio === false) {
      this.selectedChildCount = 0;
    }
    this.calculateDependent(this.partnerRadio, this.selectedChildCount);
    this.selectedCoverage.emit({ term: this.selectedTerm, spouseSelected: this.partnerRadio, childSelected: this.childRadio, selectedChildCount: this.selectedChildCount });
    // if (this.partnerRadio || this.childRadio) {
    // } else {
    //   //this.selectedCoverage.emit(false);
    // }
  }

  selectedChildCountUpdate(value: any): void {
    if (value > 10) {
      setTimeout(() => {
        this.selectedChildCount = 10;
      }, 0);
    } else {
      this.selectedChildCount = value;
      this.calculateDependent(this.partnerRadio, this.selectedChildCount);
    }

  }
  formatDate(e: any): string {
    if (e && moment(e.toString(), 'MM/DD/YYYY', true).isValid()) {
      return e;
    }
    else if (e) {
      const date = e.toString().split(' ');
      return date.length >= 4 ? moment([date[0], date[1], date[2], date[3]].join(' ')).format('MM/DD/YYYY') : moment(e).format('MM/DD/YYYY');
    }
    else {
      return e;
    }
  }
  checkDeadline(enroll_deadline, enroll_soft_deadline){
    if(enroll_soft_deadline){
     const  deadline = this.formatDate(enroll_deadline);
     const softDeadline= this.formatDate(enroll_soft_deadline);
      const today =this.formatDate(new Date()); 
      if(deadline >= softDeadline && today <= softDeadline){
        return softDeadline;
      }else{
        return deadline;
      }
    }else{
      return this.formatDate(enroll_deadline);
    }

  }
  getChildCount(value): void {
    this.selectedChildCount = value.count;
    this.calculateDependent(this.partnerRadio, this.selectedChildCount);
    if (value.count === 'Other') {
      this.showInput = true;
    } else {
      this.showInput = false;
    }
  }
}
